export default __webpack_public_path__ + "static/media/lush2.55e2a069.webp";